import { AbstractControl } from '@angular/forms';

export function phoneNumberValidator(control: AbstractControl) {
  const value = control.value;

  if (!value) {
    return null;
  }

  return /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/g.test(value)
    ? null
    : { tel: true };
}
